import apiClient from "./ApiInterceptor";

export const fetchPCC = async () => {
    const response = await apiClient.get(`/pcc`);
    return response;
};

export const fetchUserPCC = async () => {
    const response = await apiClient.get(`/pcc/user`);
    return response;
};

export const fetchPCCComents = async (pqrId) => {
    const response = await apiClient.get(`/pcc/${pqrId}/comments`);
    return response;
};

export const addPCCComment = async (pccId, comment) => {
    const params = { comment: comment }
    const response = await apiClient.post(`/pcc/${pccId}/comments`, params);
    return response;
};

export const createPCC = async (comment) => {
    const params = { comment: comment }
    const response = await apiClient.post(`/pcc`, params);
    return response;
};

export const updatePCCPriority = async (pccId, priority) => {
    const response = await apiClient.patch(`/pcc/${pccId}`, { priority: priority });
    return response;
};

export const updatePCCStatus = async (pccId, status) => {
    const response = await apiClient.patch(`/pcc/${pccId}`, { status: status });
    return response;
};

export const updatePCCAssigned = async (pccId, assigned_id) => {
    const response = await apiClient.patch(`/pcc/${pccId}`, { assigned_id: assigned_id });
    return response;
};

export const fetchPCCStatusHistory = async (pqrId) => {
    const response = await apiClient.get(`/pcc/${pqrId}/status-history`);
    return response;
};

export const fetchPCCAssignedHistory = async (pqrId) => {
    const response = await apiClient.get(`/pcc/${pqrId}/assigned-history`);
    return response;
};

export const fetchAssignables = async () => {
    const response = await apiClient.get('/pcc/assignables');
    return response;
}
